module.exports = __webpack_public_path__ + "img/区域矩形-激活.04b9e9d5.png";